import { render, staticRenderFns } from "./percentage-bar.vue?vue&type=template&id=40f8cb87&scoped=true&"
import script from "./percentage-bar.vue?vue&type=script&lang=ts&"
export * from "./percentage-bar.vue?vue&type=script&lang=ts&"
import style0 from "./percentage-bar.vue?vue&type=style&index=0&id=40f8cb87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8cb87",
  null
  
)

export default component.exports